import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';
import configureStore from './store/configure';

import ConnectedConfig from './config';
import { getOrderedStages } from 'bundles/apex/helpers/stages';

export default class PlaybooksConfig extends React.Component {
  static propTypes = {
    canEditPropertyTypes: PropTypes.bool.isRequired,
    canRequirePlaybookTasks: PropTypes.bool.isRequired,
    dealTypeOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    listingStatuses: PropTypes.array.isRequired,
    listingTypeOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    offices: PropTypes.array.isRequired,
    paths: PropTypes.shape({
      dealPlaybookIndex: PropTypes.string.isRequired,
      listingPlaybookIndex: PropTypes.string.isRequired,
    }).isRequired,
    playbookRecordType: PropTypes.string.isRequired,
    propertyTypeOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })).isRequired,
    stagesConfig: PropTypes.object.isRequired,
    users: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props);
    this.store = configureStore({
      canEditPropertyTypes: props.canEditPropertyTypes,
      canRequirePlaybookTasks: props.canRequirePlaybookTasks,
      paths: props.paths,
      playbookRecordType: props.playbookRecordType,
      playbookType: (props.playbookRecordType === 'deal' ? props.dealTypeOptions : props.listingTypeOptions)[0].value,
      playbookTypeOptions: (props.playbookRecordType === 'deal' ? props.dealTypeOptions : props.listingTypeOptions),
      propertyTypeOptions: props.propertyTypeOptions,
      stage: getOrderedStages(props.stagesConfig)[0],
      stages: props.stagesConfig,
      status: props.listingStatuses[0],
      statusOptions: props.listingStatuses,
      users: props.users,
      offices: props.offices,
    });
  }

  render() {
    return (
      <Provider store={this.store}>
        <ConnectedConfig />
      </Provider>
    );
  }
}
